import React, { useState, useEffect } from 'react';
import logo from '../../Images/logo-reze-xiii_transparent.png';
import ballonRugby from '../../Images/ballon-rugby-6.png';
import './Logo.css';

interface LogoProps {
  rotated?: boolean;
}

const ANIMATION_DURATION = 750; // ms, doit correspondre a la duree CSS
const HALO_DURATION = 1500; // ms, durée d'affichage du halo

const Logo: React.FC<LogoProps> = ({ rotated = false }) => {
  const [isBallon, setIsBallon] = useState<boolean>(false);
  const [isAnimating, setIsAnimating] = useState<boolean>(false);
  const [showHalo, setShowHalo] = useState<boolean>(false);

  // Precharge l'image du ballon uniquement si rotated est true.
  useEffect(() => {
    if (rotated) {
      const img = new window.Image();
      img.src = ballonRugby;
    }
  }, [rotated]);

  const handleClick = () => {
    if (!rotated || isAnimating) return;
    setIsAnimating(true);
    setShowHalo(true);

    // Change l'image a mi-animation (180 degres).
    setTimeout(() => {
      setIsBallon(prev => !prev);
    }, ANIMATION_DURATION / 2);

    // Fin de l'animation
    setTimeout(() => {
      setIsAnimating(false);
    }, ANIMATION_DURATION);

    // Retirer le halo
    setTimeout(() => {
      setShowHalo(false);
    }, HALO_DURATION);
  };

  const className = `logo${isAnimating ? ' rotate-animation' : ''}${showHalo ? ' halo' : ''}`;

  return (
    <img
      src={isBallon ? ballonRugby : logo}
      className={className}
      alt={
        isBallon
          ? 'Ballon de rugby Rezé XIII'
          : 'Logo du club de rugby Rezé XIII'
      }
      onClick={handleClick}
      style={{ cursor: rotated ? 'pointer' : 'default' }}
      draggable={false}
    />
  );
};

export default Logo;
